import {Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {TestSuiteData} from '../testsuite.component';
import {MatDialogRef} from '@angular/material';
import {trigger, state, animate, transition, style} from '@angular/animations';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {Color} from 'ng2-charts';
import {ChartOptions} from 'chart.js';

export interface TestSuiteData {
    testSuitePayload;
    testSuiteResponse;
}

declare let $;

@Component({
    selector: 'app-test-report',
    templateUrl: './test-report.component.html',
    styleUrls: ['./test-report.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0'})),
            state('expanded', style({height: '*'})),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ]
})
export class TestReportComponent implements OnInit, OnChanges {

    constructor(@Optional() public dialogRef: MatDialogRef<TestReportComponent>,
                public platform: LeftpanelComponent,
                @Optional() @Inject(MAT_DIALOG_DATA) public data: TestSuiteData) {

        if (data) {
            this.testSuiteResponse = data.testSuiteResponse;
            this.testSuitePayload = data.testSuitePayload;
            this.isDialogBox = true;
        }
    }

    isDialogBox = false;

    currentTable = 'Test Setup';
    @Input() testSuiteResponse;
    @Input() testSuitePayload = {};
    @Input() reportName: string;
    showAssertionDetails = [];
    columnsToDisplay = ['Test Case Name', 'Status', 'Assertion Status'];
    expandedElement;
    exceptions = [];
    sideNavButtons = [
        {
            'name': 'Dashboard',
            'function': 'showDashboard()',
            'icon': 'fa-bar-chart'
        },
        {
            'name': 'Failures',
            'function': 'showFailures()',
            'icon': 'fa-bug'
        },
        // {
        //     'name': 'Testcases',
        //     'function': 'showTestcases()',
        //     'icon': 'fa-bars'
        // }
    ];
    showDashboardData = true;
    showFailureData = false;
    showTestacasesData = false;
    currentTestCase = '';
    currentFailedTestCase = '';
    testCases = [];
    failedTestCases = [];
    currentTestcaseResponse = [];
    testCaseFilter = [];

    totalTests = 0;
    totalPassedTests = 0;
    totalFailedTests = 0;
    totalSkippedTests = 0;

    totalAssertions = 0;
    totalPassedAssertions = 0;
    totalFailedAssertions = 0;
    totalSkippedAssertions = 0;

    currentActiveIndex = 0;

    noTestFlag = false;

    chartLabels: string[] = ['Passed', 'Failed', 'Skipped'];
    chartData: number[] = [0, 0, 0];
    chartType = 'doughnut';
    colors: Color[] = [
        {
            backgroundColor: [
                '#00af00',
                '#f7464a',
                '#ff9900'
            ]
        }
    ];
    options: ChartOptions = {
        legend: {
            display: true,
            position: 'right'
        },
        plugins: {
            title: {
                display: true,
                text: 'Tests',
                padding: {
                    top: 10,
                    bottom: 30
                }
            }
        }
    };

    assertionOptions: ChartOptions = {
        legend: {
            display: true,
            position: 'right'
        },
        plugins: {
            title: {
                display: true,
                text: 'Assertions',
                padding: {
                    top: 10,
                    bottom: 30
                }
            }
        }
    };

    tabChangeLoading = false;

    assertionChartData: number[] = [0, 0, 0];
    reportTitle = '';

    // dataSource = {'testCaseResults':[{'apiResponse':{'statusCode':200,'statusLine':'HTTP/1.1 200 ','body':'[]','headers':[{'name':'Date','value':'Mon, 26 Jul 2021 05:43:31 GMT'},{'name':'Content-Type','value':'application/json;charset=UTF-8'},{'name':'Transfer-Encoding','value':'chunked'},{'name':'Connection','value':'keep-alive'},{'name':'RateLimit-Remaining','value':'4'},{'name':'RateLimit-Reset','value':'29'},{'name':'X-RateLimit-Limit-Minute','value':'5'},{'name':'X-RateLimit-Remaining-Minute','value':'4'},{'name':'RateLimit-Limit','value':'5'},{'name':'Cache-Control','value':'no-store, must-revalidate'},{'name':'vary','value':'Origin'},{'name':'Access-Control-Allow-Origin','value':'*'},{'name':'X-Kong-Upstream-Latency','value':'72'},{'name':'X-Kong-Proxy-Latency','value':'81'},{'name':'Via','value':'kong/2.4.1'}],'cookies':{},'sessionId':null,'timeInMillis':254,'contentLength':2,'attributes':[]},'startTime':1627234313493,'endTime':1627234313479,'name':'case1','result':{'status':'success'},'rules':[{'executor_type':'logic_compare','operator':'=','leftOperand':{'name':'a','type':'attributes','field':'API_gettestapi2_v1>response.statusCode','disabled':false},'rightOperand':{'executor_type':'math_number','field':'200','disabled':false},'disabled':false,'result':{'status':'success','fieldValue':'200'}},{'executor_type':'logic_compare','operator':'<','leftOperand':{'name':'a','type':'attributes','field':'API_gettestapi2_v1>response.body','disabled':false},'rightOperand':{'executor_type':'text','field':'zxvzsc','disabled':false},'disabled':false,'result':{'status':'success','fieldValue':'200'}}]},{'apiResponse':{'statusCode':200,'statusLine':'HTTP/1.1 200 ','body':'[]','headers':[{'name':'Date','value':'Mon, 26 Jul 2021 05:43:31 GMT'},{'name':'Content-Type','value':'application/json;charset=UTF-8'},{'name':'Transfer-Encoding','value':'chunked'},{'name':'Connection','value':'keep-alive'},{'name':'X-RateLimit-Remaining-Minute','value':'3'},{'name':'X-RateLimit-Limit-Minute','value':'5'},{'name':'RateLimit-Remaining','value':'3'},{'name':'RateLimit-Limit','value':'5'},{'name':'RateLimit-Reset','value':'29'},{'name':'Cache-Control','value':'no-store, must-revalidate'},{'name':'vary','value':'Origin'},{'name':'Access-Control-Allow-Origin','value':'*'},{'name':'X-Kong-Upstream-Latency','value':'93'},{'name':'X-Kong-Proxy-Latency','value':'75'},{'name':'Via','value':'kong/2.4.1'}],'cookies':{},'sessionId':null,'timeInMillis':237,'contentLength':2,'attributes':[]},'startTime':1627234313493,'endTime':1627234313479,'name':'case2','result':{'status':'failure','errorType':'assertion'},'rules':[{'executor_type':'logic_compare','operator':'=','leftOperand':{'name':'a','type':'attributes','field':'API_gettestapi2_v1>response.statusCode','disabled':false},'rightOperand':{'executor_type':'math_number','field':'200','disabled':false},'disabled':false,'result':{'status':'success','fieldValue':'200'}},{'executor_type':'logic_compare','operator':'<','leftOperand':{'name':'a','type':'attributes','field':'API_gettestapi2_v1>response.body','disabled':false},'rightOperand':{'executor_type':'text','field':'zxvzsc','disabled':false},'disabled':false,'result':{'status':'failure','fieldValue':'401'}}]},{'apiResponse':{'statusCode':200,'statusLine':'HTTP/1.1 200 ','body':'[]','headers':[{'name':'Date','value':'Mon, 26 Jul 2021 05:43:32 GMT'},{'name':'Content-Type','value':'application/json;charset=UTF-8'},{'name':'Transfer-Encoding','value':'chunked'},{'name':'Connection','value':'keep-alive'},{'name':'X-RateLimit-Remaining-Minute','value':'2'},{'name':'X-RateLimit-Limit-Minute','value':'5'},{'name':'RateLimit-Remaining','value':'2'},{'name':'RateLimit-Reset','value':'29'},{'name':'RateLimit-Limit','value':'5'},{'name':'Cache-Control','value':'no-store, must-revalidate'},{'name':'vary','value':'Origin'},{'name':'Access-Control-Allow-Origin','value':'*'},{'name':'X-Kong-Upstream-Latency','value':'165'},{'name':'X-Kong-Proxy-Latency','value':'62'},{'name':'Via','value':'kong/2.4.1'}],'cookies':{},'sessionId':null,'timeInMillis':287,'contentLength':2,'attributes':[]},'startTime':1627234313493,'endTime':1627234313479,'name':'case3','result':{'status':'success'},'rules':[{'executor_type':'logic_compare','operator':'=','leftOperand':{'name':'a','type':'attributes','field':'API_gettestapi2_v1>response.statusCode','disabled':false},'rightOperand':{'executor_type':'math_number','field':'200','disabled':false},'disabled':false,'result':{'status':'success','fieldValue':'200'}},{'executor_type':'logic_compare','operator':'<','leftOperand':{'name':'a','type':'attributes','field':'API_gettestapi2_v1>response.body','disabled':false},'rightOperand':{'executor_type':'text','field':'zxvzsc','disabled':false},'disabled':false,'result':{'status':'success','fieldValue':'200'}}]},{'apiResponse':{'statusCode':200,'statusLine':'HTTP/1.1 200 ','body':'[]','headers':[{'name':'Date','value':'Mon, 26 Jul 2021 05:43:32 GMT'},{'name':'Content-Type','value':'application/json;charset=UTF-8'},{'name':'Transfer-Encoding','value':'chunked'},{'name':'Connection','value':'keep-alive'},{'name':'RateLimit-Remaining','value':'1'},{'name':'RateLimit-Reset','value':'28'},{'name':'X-RateLimit-Limit-Minute','value':'5'},{'name':'X-RateLimit-Remaining-Minute','value':'1'},{'name':'RateLimit-Limit','value':'5'},{'name':'Cache-Control','value':'no-store, must-revalidate'},{'name':'vary','value':'Origin'},{'name':'Access-Control-Allow-Origin','value':'*'},{'name':'X-Kong-Upstream-Latency','value':'75'},{'name':'X-Kong-Proxy-Latency','value':'3'},{'name':'Via','value':'kong/2.4.1'}],'cookies':{},'sessionId':null,'timeInMillis':133,'contentLength':2,'attributes':[]},'startTime':1627234313493,'endTime':1627234313479,'name':'case4','result':{'status':'failure','errorType':'assertion'},'rules':[{'executor_type':'logic_compare','operator':'=','leftOperand':{'name':'a','type':'attributes','field':'API_gettestapi2_v1>response.statusCode','disabled':false},'rightOperand':{'executor_type':'math_number','field':'200','disabled':false},'disabled':false,'result':{'status':'success','fieldValue':'200'}},{'executor_type':'logic_compare','operator':'<','leftOperand':{'name':'a','type':'attributes','field':'API_gettestapi2_v1>response.body','disabled':false},'rightOperand':{'executor_type':'text','field':'zxvzsc','disabled':false},'disabled':false,'result':{'status':'success','fieldValue':'200'}},{'executor_type':'logic_compare','operator':'<','leftOperand':{'name':'a','type':'attributes','field':'API_gettestapi2_v1>response.body','disabled':false},'rightOperand':{'executor_type':'text','field':'zxvzsc','disabled':false},'disabled':false,'result':{'status':'failure','fieldValue':'404'}}]},{'apiResponse':{'statusCode':200,'statusLine':'HTTP/1.1 200 ','body':'[]','headers':[{'name':'Date','value':'Mon, 26 Jul 2021 05:43:32 GMT'},{'name':'Content-Type','value':'application/json;charset=UTF-8'},{'name':'Transfer-Encoding','value':'chunked'},{'name':'Connection','value':'keep-alive'},{'name':'X-RateLimit-Remaining-Minute','value':'0'},{'name':'X-RateLimit-Limit-Minute','value':'5'},{'name':'RateLimit-Remaining','value':'0'},{'name':'RateLimit-Limit','value':'5'},{'name':'RateLimit-Reset','value':'28'},{'name':'Cache-Control','value':'no-store, must-revalidate'},{'name':'vary','value':'Origin'},{'name':'Access-Control-Allow-Origin','value':'*'},{'name':'X-Kong-Upstream-Latency','value':'59'},{'name':'X-Kong-Proxy-Latency','value':'2'},{'name':'Via','value':'kong/2.4.1'}],'cookies':{},'sessionId':null,'timeInMillis':124,'contentLength':2,'attributes':[]},'startTime':1627234313493,'endTime':1627234313479,'name':'case5','result':{'status':'success'},'rules':[{'executor_type':'logic_compare','operator':'=','leftOperand':{'name':'a','type':'attributes','field':'API_gettestapi2_v1>response.statusCode','disabled':false},'rightOperand':{'executor_type':'math_number','field':'200','disabled':false},'disabled':false,'result':{'status':'success','fieldValue':'200'}},{'executor_type':'logic_compare','operator':'<','leftOperand':{'name':'a','type':'attributes','field':'API_gettestapi2_v1>response.body','disabled':false},'rightOperand':{'executor_type':'text','field':'zxvzsc','disabled':false},'disabled':false,'result':{'status':'success','fieldValue':'200'}}]}],'preStepResults':[],'tearDownStepResults':[]};

    ngOnInit() {
        this.setContent();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.setContent();
    }

    setResult(id, i) {
        // const index = this.resultsData.findIndex(value => value['name'] === reportName && value['timestamp'] === timestamp);
        // this.testSuiteResponse = JSON.parse(this.resultsData[index]['response']['body']);
        // this.reportName = this.resultsData[index]['name'] + '(' + this.resultsData[index]['version'] + ')';
        this.currentActiveIndex = i;
        this.currentTestcaseResponse = this.testSuiteResponse['testCaseResults'][i];
        this.tabChangeLoading = true;
        setTimeout(() => {
            this.tabChangeLoading = false;
        }, 100);
    }

    getDataAndTime(timeStamp) {
        if (timeStamp) {
            const date_ob = new Date(timeStamp);
            let hours = date_ob.getHours();
            const minutes = ('0' + date_ob.getMinutes()).slice(-2);
            const seconds = ('0' + date_ob.getSeconds()).slice(-2);
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12;


            return (date_ob.toDateString()) + ' ' + hours + ':' + minutes + ':' + seconds + ' ' + ampm;
        } else {
            return '-';
        }
    }

    setContent() {
        this.totalTests = 0;
        this.totalPassedTests = 0;
        this.totalFailedTests = 0;
        this.currentTestCase = '';
        this.currentFailedTestCase = '';
        this.totalFailedAssertions = 0;
        this.totalAssertions = 0;
        this.totalPassedAssertions = 0;

        this.failedTestCases = [];
        this.testCases = [];
        this.reportTitle = this.testSuitePayload['name'] ? this.testSuitePayload['name'] : '';

        if (this.reportName) {
            this.reportTitle = this.reportName;
        }

        if (this.testSuiteResponse) {
            for (const testCase of this.testSuiteResponse['testCaseResults']) {
                this.totalTests++;
                if (testCase['status'] === 'success') {
                    this.totalPassedTests++;
                }
                if (testCase['status'] === 'failure') {
                    this.totalFailedTests++;
                    this.failedTestCases.push({'name': testCase['name'],
                        'class': testCase['name'].split(' ').join('_'),
                        'status': testCase['status']});
                }

                this.testCases.push({'name': testCase['name'],
                    'sub_name': testCase['sub_name'],
                    'startTime': testCase['startTime'],
                    'class': testCase['name'].split(' ').join('_'),
                    'status': testCase['status']});
                if (this.totalTests === 1) {
                    this.currentTestCase = testCase['name'].split(' ').join('_');
                    this.currentTestcaseResponse = testCase;
                }

                if (testCase['rules']['rules']) {
                    for (const rule of testCase['rules']['rules']) {
                        this.totalAssertions++;
                        if (rule['result']['status'] === 'success') {
                            this.totalPassedAssertions++;
                        }
                        if (rule['result']['status'] === 'failure') {
                            this.totalFailedAssertions++;
                        }
                    }
                }

            }

            this.chartData = [this.totalPassedTests, this.totalFailedTests, this.totalSkippedTests];
            this.assertionChartData = [this.totalPassedAssertions, this.totalFailedAssertions, this.totalSkippedAssertions];
        }
        if (this.totalTests === 0) {
            this.noTestFlag = true;
        }
    }

    sideNavButtonClick(item) {
        switch (item.function) {
            case 'showDashboard()' :
                this.showDashboard();
                break;
            case 'showFailures()' :
                this.showFailures();
                break;
            case 'showTestcases()' :
                this.showTestcases();
                break;
        }
    }



    showDashboard() {
        this.showDashboardData = true;
        this.showFailureData = false;
        this.showTestacasesData = false;
    }

    showFailures() {
        this.showDashboardData = false;
        this.showFailureData = true;
        this.showTestacasesData = false;
    }

    showTestcases() {
        this.showDashboardData = false;
        this.showFailureData = false;
        this.showTestacasesData = true;
    }

    setCurrentTestCase(testCase) {
        this.currentTestCase = testCase.class;
        const index = this.testSuiteResponse.testCaseResults.findIndex(value => value['name'] === testCase['name']);
        this.currentTestcaseResponse = this.testSuiteResponse.testCaseResults[index];
    }

    setTestCaseFilter(val) {
        this.testCaseFilter = val;

        this.noTestFlag = false;
        this.testCases = [];
        if (this.testSuiteResponse) {
            let testCount = 0;
            for (const testCase of this.testSuiteResponse['testCaseResults']) {
                if (testCase['status'] === 'success' && val.includes('success')) {
                    this.testCases.push({'name': testCase['name'],
                        'startTime': testCase['startTime'],
                        'sub_name': testCase['sub_name'],
                        'class': testCase['name'].split(' ').join('_'),
                        'status': testCase['status']});
                    testCount++;
                }
                if (testCase['status'] === 'failure' && val.includes('failure')) {
                    this.testCases.push({'name': testCase['name'],
                        'startTime': testCase['startTime'],
                        'sub_name': testCase['sub_name'],
                        'class': testCase['name'].split(' ').join('_'),
                        'status': testCase['status']});
                    testCount++;
                }
                if (testCount === 1) {
                    this.currentTestCase = testCase['name'].split(' ').join('_');
                    this.currentTestcaseResponse = testCase;
                    testCount++;
                }
            }
            if (testCount === 0) {
                this.noTestFlag = true;
            }
        }
    }

    setCurrentFailedTestCase(testCase) {
        this.currentFailedTestCase = testCase.class;
    }

    getDate(val) {
        if (val) {
            return this.platform.timeConverter(val);
        }
        return '';
    }

    getTime(val) {
        if (val) {
            const date_ob = new Date(val);
            let hours = date_ob.getHours();
            const minutes = ('0' + date_ob.getMinutes()).slice(-2);
            const seconds = ('0' + date_ob.getSeconds()).slice(-2);
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12;

            return hours + ':' + minutes + ':' + seconds + ' ' + ampm;
        }
        return '';
    }

    getStatusCodeClass(val) {
        if (200 <= val && val < 300) {
            return 'success';
        } else if (300 <= val && val < 400) {
            return 'redirects';
        } else if (400 <= val && val < 500) {
            return 'dependencyError';
        } else if (val > 500) {
            return 'serverError';
        }
    }

    getSelectedFilter(val) {
        if (val === 'pass') {
            return (this.testCaseFilter.includes('success') && this.testCaseFilter.length === 1) ? 'filter-selected' : '';
        } else if (val === 'fail') {
            return (this.testCaseFilter.includes('failure') && this.testCaseFilter.length === 1) ? 'filter-selected' : '';
        } else if (val === 'skip') {
            return (this.testCaseFilter.includes('skipped') && this.testCaseFilter.length === 1) ? 'filter-selected' : '';
        } else if (val === 'clear') {
            return (this.testCaseFilter.length === 3) ? 'filter-selected' : '';
        }
    }

    getStatusName(val) {
        if (val === 'success') {
            return 'Pass';
        } else {
            return 'Fail';
        }
    }

    public chartClicked(e) {
        // console.log(e);
    }

    public chartHovered(e) {
        // console.log(e);
    }

}
